import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/img/lottery_title.png'
import _imports_1 from '../assets/img/letter_back.png'
import _imports_2 from '../assets/img/letter_door_back.png'
import _imports_3 from '../assets/img/letter_bg.png'
import _imports_4 from '../assets/img/letter_door_bg.png'
import _imports_5 from '../assets/img/back_btn.png'
import _imports_6 from '../assets/img/share_btn.png'


const _hoisted_1 = { class: "page-lottery" }
const _hoisted_2 = { class: "lottery-inner" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "lottery-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "letter-back" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "letter-door-back" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1)
const _hoisted_6 = { class: "letter-content" }
const _hoisted_7 = { class: "avatar" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "nick-name" }
const _hoisted_10 = {
  key: 0,
  class: "prize-wrapper"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "code" }, "中奖券码请在首页“中奖记录”内查看。", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = {
  key: 1,
  class: "blessing"
}
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"letter-bg\"><img src=\"" + _imports_3 + "\" alt=\"\"></div><div class=\"letter-door\"><img src=\"" + _imports_4 + "\" alt=\"\"><img src=\"" + _imports_2 + "\" alt=\"\"></div>", 2)
const _hoisted_16 = { class: "lottery-btns" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1)
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["lottery-container", [_ctx.isOpening && 'open']])
      }, [
        _hoisted_3,
        _createElementVNode("div", {
          class: "letter",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.open && _ctx.open(...args)))
        }, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("img", {
                src: _ctx.defaultUser(_ctx.userInfo.avatar),
                alt: ""
              }, null, 8, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.userInfo.nickname), 1),
            (_ctx.prizeData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("p", null, [
                    _createTextVNode("恭喜你获得"),
                    _hoisted_12,
                    _createTextVNode(_toDisplayString(_ctx.prizeData.name), 1)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.blessing), 1)
                ]))
          ]),
          _hoisted_14
        ])
      ], 2),
      _createElementVNode("div", _hoisted_16, [
        _withDirectives(_createElementVNode("div", {
          class: "btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
        }, _hoisted_18, 512), [
          [_vShow, _ctx.isOpened]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "btn",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.share && _ctx.share(...args)))
        }, _hoisted_20, 512), [
          [_vShow, _ctx.isOpened]
        ])
      ])
    ])
  ]))
}